import {
  FeatureName,
  StatusConfig,
  StatusState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useController } from 'react-hook-form';
import { string, object as yupObject } from 'yup';
import { useFormContext } from '../../forms';
import { RoutineExecutionForm, RoutineExecutionFormProps } from '../types';
import { OpenEndedResponseExecutionComponent } from './openEndedResponseExecutionComponent';
import { StatusExecutionComponent } from './statusExecutionComponent';
import { OpenEndedResponse } from './types';

export const getExecutionFormResolver = (state: any) => {
  const validationSchema = yupObject({
    status: string().required().nonNullable(),
    openEndedResponse: string().when('status', {
      is: OpenEndedResponse,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    }),
  });

  return yupResolver(validationSchema);
};

export const getExecutionFormDefaultValues = (
  _: StatusConfig,
  state?: StatusState
) => {
  return {
    status: state?.status,
    openEndedResponse: state?.openEndedResponse,
  };
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const StatusExecutionFormOld: RoutineExecutionForm<
  StatusConfig,
  StatusState
> = (props: RoutineExecutionFormProps<StatusConfig, StatusState>) => {
  const formKey = 'status';
  const { control, setValue } = useFormContext();

  const { field } = useController({
    control: control,
    name: formKey,
  });

  useEffect(() => {
    if (props.currentState?.state?.status) {
      setValue(formKey, props.currentState.state.status, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [props.currentState]);

  const onStatusChange = (status: string) => {
    setValue(formKey, status, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <>
      <StatusExecutionComponent
        statuses={props.config.statuses}
        value={field.value}
        onChange={onStatusChange}
        disabled={props.isIssueEditRoutine}
      />
      <OpenEndedResponseExecutionComponent {...props} />
    </>
  );
};

// TODO: Crop Circle Redesign | Remove to StatusExecutionFormBase after feature is fully rolled out
const StatusExecutionFormBase: RoutineExecutionForm<
  StatusConfig,
  StatusState
> = (props: RoutineExecutionFormProps<StatusConfig, StatusState>) => {
  const formKey = 'status';
  const { control, setValue } = useFormContext();

  const { field } = useController({
    control: control,
    name: formKey,
  });

  useEffect(() => {
    if (props.currentState?.state?.status) {
      setValue(formKey, props.currentState.state.status, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [props.currentState]);

  const onStatusChange = (status: string) => {
    setValue(formKey, status, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <>
      <StatusExecutionComponent
        statuses={props.config.statuses}
        value={field.value}
        onChange={onStatusChange}
        disabled={props.isIssueEditRoutine}
        useCropCircle
      />
      <OpenEndedResponseExecutionComponent {...props} useCropCircle />
    </>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const StatusExecutionForm: RoutineExecutionForm<
  StatusConfig,
  StatusState
> = (props: RoutineExecutionFormProps<StatusConfig, StatusState>) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <StatusExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to StatusExecutionFormBase after feature is fully rolled out
  return <StatusExecutionFormBase {...props} />;
};
